import {
  BillInformation,
  BillInformationDetail,
} from '@/types/api/customerApi';

/**
 * Returns only details that belong to the selected warranty branch.
 *
 * Old API responses can omit branch_no on the parent and/or every detail.
 * A missing detail branch inherits an explicitly matching parent branch. If
 * the parent is also missing but at least one detail has a branch, unscoped
 * details are ambiguous and are excluded.
 */
export const getBillDetailsForBranch = (
  bill: BillInformation,
  currentBranchNo: number | undefined,
): BillInformationDetail[] => {
  const details = bill.bill_infomation_details ?? [];
  if (currentBranchNo === undefined) return details;

  if (bill.branch_no !== undefined) {
    if (bill.branch_no !== currentBranchNo) return [];
    return details.filter(
      (detail) =>
        detail.branch_no === undefined || detail.branch_no === currentBranchNo,
    );
  }

  const hasDetailBranch = details.some(
    (detail) => detail.branch_no !== undefined,
  );
  if (!hasDetailBranch) return details;

  return details.filter((detail) => detail.branch_no === currentBranchNo);
};
